jQuery(document).on('change', 'quantity-input button,quantity-input input', function() {
    // console.log('custom js');
    var line_item = jQuery(this).parent('quantity-input').find('input').attr('data-line-id');
    var qty = jQuery(this).parent('quantity-input').find('input').val();
    console.log(line_item + qty);
    jQuery.ajax({
        url: '/cart/change.js',
        type: 'POST',
        data: {
            quantity: qty,
            id: line_item
        },
        dataType: 'json',
        success: function(cart) {
            
             jQuery.ajax({
                url: '/cart',
                success: function(result) {
                    var html = jQuery(result).find('cart-drawer').html();
                    jQuery('cart-drawer').html(html);
                    
                }
            });  
        },
        error: function(err) {
            console.log('Error updating cart quantity', err);
        }
    });
    return false;
});
jQuery(document).on('click', 'cart-drawer-items cart-remove-button', function() {
        var line_item = jQuery(this).attr('data-line-id');
        var data = {
            "id": line_item,
            "quantity": 0,            
        }      
        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function(result){
                var count = result.item_count;
                jQuery.ajax({
                    url: '/cart',
                    success: function(result) {
                        var html = jQuery(result).find('cart-drawer').html();
                        jQuery('cart-drawer').html(html);
                        if(count == 0){
                          jQuery('cart-drawer').addClass('is-empty');
                        }
                    }
                });  
            } 
        });  
});